<template>
    <a href="javascript:void(0);"
       :id="id"
       :class="className"
       :title="title">{{ filterTitle }}
    </a>
</template>

<script>
    export default {
        name: 'DateRangeButton',
        props: {
            modelValue: {},
            id: {default: ''},
            title: {default: ''},
            defaultTitle: { default: 'Date'},
            className: {default: 'nav-link cursor-pointer'},
            format: {
                type: String,
                default: "YYYY-MM-DD"
            },
            isSingle:{
                default: false
            },
            minDate: {},
            maxDate: {},
            options: {},
        },
        data() {
            return {
                filterTitle: this.defaultTitle
            }
        },
        watch: {
            modelValue: function (val) {
                if(val == '') {
                    this.filterTitle = 'Date';
                }
            },
        },
        mounted() {
            this.$nextTick(() => {
                const el = $(this.$el);

                el.daterangepicker({
                    locale: {
                        format: this.format,
                        cancelLabel: 'Clear'
                    },
                    autoclose: true,
                    clearBtn: true,
                    autoUpdateInput: false,
                    minDate: this.minDate,
                    maxDate: this.maxDate,
                    singleDatePicker: this.isSingle,
                    ...this.options,
                });

                this.$emit("update:modelValue", this.modelValue);

                el.on("apply.daterangepicker", (event, picker) => {
                    this.filterTitle = picker.chosenLabel || this.defaultTitle;
                    const startDate = picker.startDate.format(this.format);
                    const endDate = picker.endDate.format(this.format);
                    if (this.isSingle) {
                        this.$emit("update:modelValue", startDate);
                        this.$emit("changed");
                    } else {
                        this.$emit("update:modelValue", startDate + " / " + endDate);
                        this.$emit("changed");
                    }
                });
                el.on("cancel.daterangepicker", () => {
                    this.$emit("update:modelValue", '');
                    this.filterTitle = 'Date'
                    this.$emit("changed");
                });

                $(".cancelBtn").removeClass("btn-default").addClass("btn btn-sm btn-danger");
                $(".applyBtn").addClass("btn btn-sm btn-primary");

            });

        },
        beforeUnmount() {
            $(this.$el).daterangepicker("hide").daterangepicker("destroy");
        }
    };
</script>
